import { CustomButtonColor } from '../../UiComponentsLibrary/CustomButton/constants/CustomButtonColor';

export const FORM_BUTTONS = [
  {
    id: 'edit-art-event-cancel-button',
    textKey: 'cancel-button',
    backgroundColor: CustomButtonColor.cancel,
    action: 'cancel' as const,
  },
  {
    id: 'edit-art-event-submit-button',
    textKey: 'submit-button',
    backgroundColor: CustomButtonColor.submit,
    action: 'submit' as const,
  },
];
